import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

export type DownloadRota =
    | { tipo: 'rota'; texto: string; rota: string }
    | { tipo: 'acao'; acao: () => void };

@Injectable({
    providedIn: 'root',
})
export class LayoutIndicadoresService {
    public ano = new BehaviorSubject<string>('');
    public pais = new BehaviorSubject<string>('');
    public estado = new BehaviorSubject<string>('');
    public siglaEstado = new BehaviorSubject<string>('');
    public cidade = new BehaviorSubject<string>('');
    public editavel = new BehaviorSubject<boolean>(false);

    public corBordaTag = new BehaviorSubject<string>('');
    public corTextoTag = new BehaviorSubject<string>('');
    public tituloTag = new BehaviorSubject<string>('');

    public rotaResultado = new BehaviorSubject<string>('');
    public rotaDownloadIndicadores = new BehaviorSubject<DownloadRota | null>(null);
    public rotaApresentacao = new BehaviorSubject<string>('');
    public rotaEdicaoSimulacao = new BehaviorSubject<string>('');
    public rotaFiltroLocalidade = new BehaviorSubject<string>('');

    public redeSelecionada = new BehaviorSubject<string>('');
    public textoComoCitar = new BehaviorSubject<string>('');

    public imagemFundo = new BehaviorSubject<string>('assets/ilustrations/bridge-mountain.svg');

    setAno(ano: string) {
        this.ano.next(ano);
    }

    getAno(): Observable<string> {
        return this.ano.asObservable();
    }

    setPais(pais: string) {
        this.pais.next(pais);
    }

    getPais(): Observable<string> {
        return this.pais.asObservable();
    }

    setEstado(estado: string) {
        this.estado.next(estado);
    }

    getEstado(): Observable<string> {
        return this.estado.asObservable();
    }

    setSiglaEstado(siglaEstado: string) {
        this.siglaEstado.next(siglaEstado);
    }

    getSiglaEstado(): Observable<string> {
        return this.siglaEstado.asObservable();
    }

    setCidade(cidade: string) {
        this.cidade.next(cidade);
    }

    getCidade(): Observable<string> {
        return this.cidade.asObservable();
    }

    setEditavel(editavel: boolean) {
        this.editavel.next(editavel);
    }

    getEditavel(): Observable<boolean> {
        return this.editavel.asObservable();
    }

    setCorBordaTag(corTag: string) {
        this.corBordaTag.next(corTag);
    }

    getCorBordaTag(): Observable<string> {
        return this.corBordaTag.asObservable();
    }

    setCorTextoTag(corTag: string) {
        this.corTextoTag.next(corTag);
    }

    getCorTextoTag(): Observable<string> {
        return this.corTextoTag.asObservable();
    }

    setTituloTag(tituloTag: string) {
        this.tituloTag.next(tituloTag);
    }

    getTituloTag(): Observable<string> {
        return this.tituloTag.asObservable();
    }

    setRotaResultado(rotaResultado: string) {
        this.rotaResultado.next(rotaResultado);
    }

    getRotaResultado(): Observable<string> {
        return this.rotaResultado.asObservable();
    }

    setRotaDownloadIndicadores(downloadRota: DownloadRota) {
        this.rotaDownloadIndicadores.next(downloadRota);
    }

    getRotaDownloadIndicadores(): Observable<DownloadRota | null> {
        return this.rotaDownloadIndicadores.asObservable();
    }

    setRotaApresentacao(v: string) {
        this.rotaApresentacao.next(v);
    }
    getRotaApresentacao(): Observable<string> {
        return this.rotaApresentacao.asObservable();
    }

    setRotaEdicaoSimulacao(v: string) {
        this.rotaEdicaoSimulacao.next(v);
    }
    getRotaEdicaoSimulacao(): Observable<string> {
        return this.rotaEdicaoSimulacao.asObservable();
    }

    setRotaFiltroLocalidade(rotaFiltroLocalidade: string) {
        this.rotaFiltroLocalidade.next(rotaFiltroLocalidade);
    }
    getRotaFiltroLocalidade(): Observable<string> {
        return this.rotaFiltroLocalidade.asObservable();
    }

    setRedeSelecionada(v: string) {
        this.redeSelecionada.next(v);
    }
    getRedeSelecionada(): Observable<string> {
        return this.redeSelecionada.asObservable();
    }

    setTextoComoCitar(v: string) {
        this.textoComoCitar.next(v);
    }

    getTextoComoCitar(): Observable<string> {
        return this.textoComoCitar.asObservable();
    }

    setImagemFundo(imagemFundo: string) {
        this.imagemFundo.next(imagemFundo);
    }

    getImagemFundo(): Observable<string> {
        return this.imagemFundo.asObservable();
    }
}
